import {fetchAlbumPhotos} from './fetchAlbumPhotos'
import {getAlbumTagStats} from './getAlbumTagStats'
import {getThumbnail} from './getThumbnail'
import {listPhotoPersonTags} from './listPhotoPersonTags'
import {processPhoto} from './processPhoto'
import {reprocessAlbumFaces} from './reprocessAlbumFaces'
import {deleteAlbumPhoto} from './deleteAlbumPhoto'
import {handleRotatePhotoSSE, TopicRotatePhotoComplete} from './rotatePhotoSSE'
import {rotatePhoto} from './rotatePhoto'

export const photos = {
  fetchAlbumPhotos,
  getAlbumTagStats,
  getThumbnail,
  listPhotoPersonTags,
  processPhoto,
  reprocessAlbumFaces,
  deleteAlbumPhoto,
  rotatePhoto,
  handleRotatePhotoSSE,
  TopicRotatePhotoComplete,
}
